export default __webpack_public_path__ + "static/media/search-icon.f8767868.svg";